import React, { useEffect } from "react";
import "./App.css";
import {
  AuthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus, IPublicClientApplication } from "@azure/msal-browser";
import Router from "./pages/router";
import { CustomProvider } from "rsuite";
import { loginRequest } from "./services/authConfig";
import Header from "./components/common/header";
import SupplierDashboard from "./pages/supplier";
import { MsalProvider } from "@azure/msal-react";

type AppProps = {
  pca: IPublicClientApplication;
};
function OneTrustScriptLoader() {
  useEffect(() => {
    // Only load the script if not already present
    if (!document.getElementById('onetrust-script')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.setAttribute('data-domain-script', '0198f5c8-bf0f-7cd9-94fc-615c683f770a');
      script.id = 'onetrust-script';
      document.body.appendChild(script);
    }
  }, []);

  return null; // this component doesn't render anything visible
}

function App({ pca }: AppProps) {

  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();


  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    instance.loginRedirect(loginRequest)
      .catch((error) => console.log(error));
  }


  return (
    <MsalProvider instance={pca}>
      <AuthenticatedTemplate>
        <CustomProvider theme="light">
          <Router />
          {isAuthenticated && <OneTrustScriptLoader />}
          {/* <SupplierDashboard /> */}
        </CustomProvider>
      </AuthenticatedTemplate>
    </MsalProvider>
  );
}

export default App;
